import React from 'react';
import { type File as ParsedDiffFile } from '@/shared/types/parse-diff';
import { Card, CardContent, CardHeader, CardTitle } from '@/ui/Card';

interface DiffStatsBarProps {
  files: ParsedDiffFile[];
}

const DiffStatsBar: React.FC<DiffStatsBarProps> = ({ files }) => {
  // Filter out binary files and files with no actual code changes.
  // This provides a more accurate representation of the work done, similar to GitHub's UI.
  const changedTextFiles = files.filter(file => !file.binary && file.chunks.length > 0);

  const totalAdditions = changedTextFiles.reduce(
    (sum, file) => sum + (file.additions || 0),
    0
  );
  const totalDeletions = changedTextFiles.reduce(
    (sum, file) => sum + (file.deletions || 0),
    0
  );

  return (
    <Card>
      <CardHeader className="flex-row items-center justify-between pb-2 space-y-0">
        <CardTitle className="text-base font-medium">
          Pull Request Changes
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm">
        <p className="text-muted-foreground">
          Showing <span className="font-semibold text-foreground">{changedTextFiles.length}</span> changed files
          with{' '}
          <span className="font-semibold text-green-500">
            +{totalAdditions}
          </span>{' '}
          additions and{' '}
          <span className="font-semibold text-red-500">
            -{totalDeletions}
          </span>{' '}
          deletions.
        </p>
      </CardContent>
    </Card>
  );
};

export default DiffStatsBar;
